import { css, keyframes } from 'styled-components';

const bgFade = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0.4;
  }
`;

/**
 * A CSS mixin to pass into any component you would like to
 * skelatise during loading for UX purposes
 *
 * @example
 * import styled from 'styled-components';
 * import { skeleton } from '../skeleton';
 *
 * export const Card = styled.div<{
 *   skeletal: boolean;
 * }>(({ skeletal }) => css`
 *   ${skeletal && skeleton}
 *   display: flex;
 *   // ...
 * `);
 */
export const skeleton = css`
  animation: ${bgFade} 1s linear infinite alternate;

  /* do not !important background for Firefox support */
  background: ${props => props.theme.co.neutral98};

  /* Prevent background color from extending to the border and overlappping */
  background-clip: padding-box !important;
  border-color: transparent !important;
  box-shadow: none !important;

  /* Transparent text will occupy space but be invisible to the user */
  color: transparent !important;
  cursor: default;
  pointer-events: none;
  user-select: none;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    background: ${props => props.theme.co.neutral90};
    border-radius: ${props => props.theme.bo.extraSmall};
    color: transparent !important;
    visibility: visible !important;
  }

  /* Make pseudo-elements (CSS icons) and children invisible */
  &::before,
  &::after,
  * {
    visibility: hidden !important;
  }
`;
